const se = {
  kicker: "Geahččalanveršuvdna",
  title: "Speala Trollfossjakten dál Expo Go:in.",
  lead: "Mii geahččalit áppa ja loahpahit guoibmesoahpamušaid. Olles áppa almmuhuvvo App Storei ja Google Playi ovdal guovvamánu 1. beaivvi 2027. Dassážii sáhtát speallat geahččalanveršuvnna nuvttá.",
  notice: "Geahččalanveršuvdna — juoga sáhttá rievdat ovdal álggaheami",
  step1: "Sajáiduhte Expo Go",
  step1Body: "Expo Go lea nuvttá áppa mii vuodjá min geahččalanveršuvnna. Viečča dan iežat áppagávppis.",
  step2: "Skánne koda",
  step2Body: "iPhone: skánne koda Kamera-áppain. Android: raba Expo Go ja deaddil «Scan QR code».",
  step3: "Dahje raba liŋkka telefovnnas",
  step3Body: "Leago dus juo Expo Go? Deaddil boalu telefovnnas rahpat geahččalanveršuvnna njuolgga.",
  open: "Raba Expo Go:s",
  copyLink: "Máŋge liŋkka",
  copied: "Liŋka máŋgejuvvon",
  qrAlt: "QR-koda Trollfossjakten geahččalanáppii",
  dlTitle: "Viečča geahččalanveršuvnna",
  dlExpo: "1 · Viečča Expo Go (nuvttá)",
  dlOpen: "2 · Raba min geahččalanáppa",
  dlLink: "Njuolgga liŋka",
  qrCaption: "Skánne rahpat geahččalanveršuvnna",
};

export default se;
